var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};

// react/landscape-56.js
import React from "react";
import { i18n as i18n2 } from "@lingui/core";

// src/raw/landscape/locales/nb/messages.mjs
var messages = JSON.parse('{"icon.title.landscape":"Sol og fjell"}');

// src/raw/landscape/locales/en/messages.mjs
var messages2 = JSON.parse('{"icon.title.landscape":"Sun and mountains"}');

// src/raw/landscape/locales/fi/messages.mjs
var messages3 = JSON.parse('{"icon.title.landscape":"Aurinko ja vuoret"}');

// src/utils/i18n.ts
import { i18n } from "@lingui/core";
var supportedLocales = ["en", "nb", "fi"];
var defaultLocale = "en";
var getSupportedLocale = (usedLocale) => {
  return supportedLocales.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || defaultLocale;
};
function detectLocale() {
  if (typeof window === "undefined") {
    const serverLocale = process.env.NMP_LANGUAGE || Intl.DateTimeFormat().resolvedOptions().locale;
    return getSupportedLocale(serverLocale);
  }
  try {
    const htmlLocale = document.documentElement.lang;
    return getSupportedLocale(htmlLocale);
  } catch (e) {
    console.warn("could not detect locale, falling back to source locale", e);
    return defaultLocale;
  }
}
var getMessages = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale();
  const messages4 = getMessages(locale, enMessages, nbMessages, fiMessages);
  i18n.load(locale, messages4);
  i18n.activate(locale);
};

// react/landscape-56.js
activateI18n(messages2, messages, messages3);
var title = i18n2.t({ message: `Sun and mountains`, id: "icon.title.landscape", comment: "Title for landscape icon" });
var IconLandscape56 = (attrs) => React.createElement("svg", __spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "56", height: "56", fill: "none", viewBox: "0 0 56 56", dangerouslySetInnerHTML: { __html: `<title>${title}</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM53 50 38.648 26.58A3.533 3.533 0 0 0 35.749 25a3.52 3.52 0 0 0-2.933 1.514l-9.393 13.464-5.821-4.685a3.525 3.525 0 0 0-2.749-.736 3.52 3.52 0 0 0-2.396 1.538L3 50"></path>` } }, attrs));
var landscape_56_default = IconLandscape56;
export {
  IconLandscape56,
  landscape_56_default as default
};
//# sourceMappingURL=landscape-56.js.map
